import { I18n } from '@calendly/i18n';
import { Menu } from '@calendly/ui/components/menu';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ORGANIZATION_MEMBERSHIP_ROLES } from 'constants/organization_roles';
import { useTrackNotFound } from 'hooks/member_picker/useTrackNotFound';
import { isAdminOrOwnerSelector } from 'selectors/current_user';
import { MenuItem } from './menu_item';
import { searchingSelector, suggestionsSelector, selectedSuggestionsSelector } from './selectors';
import { addSelectedSuggestion, updateOrgAdminToRemove } from './slice';
const styledMenuCss = "slt4cq4";
const StyledMenu = forwardRef((props, ref) => <Menu ref={ref} {...props} data-container="suggestions" className={classNames(styledMenuCss, props.className)} />);
const infoCss = "iayu1vt";
const Info = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoCss, props.className)} />;
});
const infoTextCss = "iod0uj";
const InfoText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoTextCss, props.className)} />;
});
const infoTitleCss = "i1wv80t4";
const InfoTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(infoTitleCss, props.className)} />;
});
export const DropdownMenu = ({
  notFoundPlaceholderTitle,
  notFoundPlaceholderText,
  getUnavailabilityReason,
  getSideEffectInfo,
  onSelect,
  showUserRole,
  showOrgAdminRemoval
}) => {
  const dispatch = useDispatch();
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector);
  const searching = useSelector(searchingSelector);
  const suggestions = useSelector(suggestionsSelector);
  const selectedSuggestions = useSelector(selectedSuggestionsSelector);
  const handleSelection = suggestion => {
    dispatch(addSelectedSuggestion(suggestion));
    if (showOrgAdminRemoval && suggestion.entity.role === ORGANIZATION_MEMBERSHIP_ROLES.ADMIN) {
      dispatch(updateOrgAdminToRemove({
        isOrgAdminToRemove: false,
        type: suggestion.type,
        entity: suggestion.entity
      }));
    }
    onSelect(suggestion);
  };
  useTrackNotFound(!searching && !suggestions.length, isAdminOrOwner);
  if (searching) {
    return <StyledMenu>
        <Info>
          <InfoText>{I18n.t('publisher.organization.memberships_picker.searching')}</InfoText>
        </Info>
      </StyledMenu>;
  }
  if (!suggestions.length) {
    return <StyledMenu>
        <Info>
          <InfoTitle>
            {notFoundPlaceholderTitle || I18n.t('publisher.organization.memberships_picker.not_found')}
          </InfoTitle>
          {notFoundPlaceholderText && <InfoText>{notFoundPlaceholderText}</InfoText>}
        </Info>
      </StyledMenu>;
  }
  return <StyledMenu>
      {suggestions.map(suggestion => <MenuItem showUserRole={showUserRole} key={suggestion.id} suggestion={suggestion} isSelected={selectedSuggestions.some(({
      id
    }) => id === suggestion.id)} getUnavailabilityReason={getUnavailabilityReason} getSideEffectInfo={getSideEffectInfo} onSelect={handleSelection} />)}
    </StyledMenu>;
};

require("./dropdown_menu.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./dropdown_menu.js");